import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Table, TableRow, TableCell } from "@mui/material";

import "./SewerObjectPopupModal.scss";
import { getTranslationKeyForType } from "../../services/sewer-object/SewerObject";
import { translationService } from "../../services/translation/TranslationService";
import { SewerObjectType } from "../../generated/SewerObjects";

export default observer(
  ({ selectedShape, historyPath }: { selectedShape: any; historyPath: string }) => {
    const item = useMemo(() => selectedShape?.data.properties, [selectedShape]);

    const bluemetricFields = useMemo(
      () => (item ? Object.keys(item.details).filter((f) => item?.details[f].metadata.name) : []),
      [item]
    );

    const sewerObjectPath = useMemo(
      () =>
        Object.keys(SewerObjectType)
          .filter((e) => isNaN(Number(e)))
          .map((t) => `/sewer-objects/${t.toLowerCase()}/`)
          .some((p) => historyPath.includes(p))
          ? `../../${SewerObjectType[item?.mapObjectType]?.toLowerCase()}/${item?.mapObjectId}`
          : `./sewer-objects/${SewerObjectType[item?.mapObjectType]?.toLowerCase()}/${item?.mapObjectId}`,
      [historyPath, item?.mapObjectId, item?.mapObjectType]
    );

    return (
      <div className="sewer-object-modal">
        <div className="title">
          {translationService.translate("SewerObjectMapModal.object-details")}
        </div>
        <Table>
          <TableRow key="name">
            <TableCell>
              {translationService.translate("general.sewer-objects.list-header.sewer-object-id")}
            </TableCell>
            <TableCell>
              <a className="link" href={sewerObjectPath}>
                {item?.details.Name.toDisplay}
              </a>
            </TableCell>
          </TableRow>
          <TableRow key="type">
            <TableCell>
              {translationService.translate("general.type")}
            </TableCell>
            <TableCell>
              {translationService.translate(getTranslationKeyForType(item?.details.Type.value))}
            </TableCell>
          </TableRow>
          <TableRow key="inspections">
            <TableCell>{translationService.translate("general.inspections")}</TableCell>
            <TableCell>{item?.details.InspectionsCount.toDisplay}</TableCell>
          </TableRow>
          {bluemetricFields.map((f) => {
            return (
              <TableRow key={f}>
                <TableCell>{item?.details[f].metadata.name}</TableCell>
                <TableCell>{item?.details[f].toDisplay || " — "}</TableCell>
              </TableRow>
            );
          })}
          <TableRow key="modified">
            <TableCell>
              {translationService.translate("general.last-edit")}
            </TableCell>
            <TableCell>{item?.details.Modified.toDisplay}</TableCell>
          </TableRow>
        </Table>
      </div>
    );
  }
);
